module.exports = __webpack_public_path__ + "static/image8-a7a2403b28b155627d548bd38101aa17.png";